import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavComponent } from './nav/nav.component';
import { MaterialModule } from '../material.module';
import { RouterModule } from '@angular/router';
import { SuiteModule } from '@soleran/suite';
import { ApplicationModule } from '@soleran/application';
import { ModuleModule } from '@soleran/module';

import { DefaultLayoutComponent } from './default-layout.component';
import { TopbarComponent } from './topbar/topbar.component';
import { QueryPickerModule, SolCommonModule } from '@soleran/common';
import { UserAvatarModule } from '@soleran/authentication';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { SearchModuleModule } from '@soleran/audit';
import { ModulePickerComponent } from './module-picker/module-picker.component';
import { GlobalSearchModule } from './global-search/global-search.module';

@NgModule({
  declarations: [
    NavComponent,
    DefaultLayoutComponent,
    TopbarComponent,
    // ModulePickerComponent,
  ],
  imports: [
    CommonModule,
    GlobalSearchModule,
    QueryPickerModule,
    MaterialModule,
    RouterModule,
    ApplicationModule,
    SuiteModule,
    ModuleModule,
    SolCommonModule,
    UserAvatarModule,
    MatMenuModule,
    MatDialogModule,
    SearchModuleModule,
    // .forRoot({
    //   apiBaseUrl: 'https://localhost:44381',
    // }),
  ],
  exports: [
    NavComponent,

    // ModulePickerComponent
  ],
})
export class SharedModule {}
